"use client";

import { useParams } from "next/navigation";
import ReactDOM from "react-dom";

import waldenburgBuch from "@ui/fonts/waldenburg/KMR-Waldenburg-Buch.woff2";
import waldenburgBuchLatin from "@ui/fonts/waldenburg/KMR-Waldenburg-Buch-latin.woff2";
import waldenburgFett from "@ui/fonts/waldenburg/KMR-Waldenburg-Fett.woff2";
import waldenburgFettLatin from "@ui/fonts/waldenburg/KMR-Waldenburg-Fett-latin.woff2";
import waldenburgFettHalbschmal from "@ui/fonts/waldenburg/KMR-Waldenburg-FettHalbschmal.woff2";
import waldenburgFettHalbschmalLatin from "@ui/fonts/waldenburg/KMR-Waldenburg-FettHalbschmal-latin.woff2";
import waldenburgNormal from "@ui/fonts/waldenburg/KMR-Waldenburg-Normal.woff2";
import waldenburgNormalLatin from "@ui/fonts/waldenburg/KMR-Waldenburg-Normal-latin.woff2";

const fontPaths = {
  default: {
    buch: waldenburgBuch,
    normal: waldenburgNormal,
    fett: waldenburgFett,
    fettHalbschmal: waldenburgFettHalbschmal,
  },
  en: {
    buch: waldenburgBuchLatin,
    normal: waldenburgNormalLatin,
    fett: waldenburgFettLatin,
    fettHalbschmal: waldenburgFettHalbschmalLatin,
  },
} as const;

export const FontPreloader = () => {
  const params = useParams();
  const locale = params?.locale as string;
  const isEnglish = locale === "en";
  const waldenburgFonts = isEnglish ? fontPaths.en : fontPaths.default;

  ReactDOM.preconnect("https://eleven-public-cdn.elevenlabs.io", { crossOrigin: "anonymous" });

  // Preload fonts based on locale
  ReactDOM.preload(waldenburgFonts.buch, {
    as: "font",
    type: "font/woff2",
    crossOrigin: "anonymous",
  });

  ReactDOM.preload(waldenburgFonts.normal, {
    as: "font",
    type: "font/woff2",
    crossOrigin: "anonymous",
  });

  ReactDOM.preload(waldenburgFonts.fett, {
    as: "font",
    type: "font/woff2",
    crossOrigin: "anonymous",
  });

  ReactDOM.preload(waldenburgFonts.fettHalbschmal, {
    as: "font",
    type: "font/woff2",
    crossOrigin: "anonymous",
  });

  return null;
};
